import type { ReactNode } from 'react';
import { ModalDialog } from './ModalDialog';

export interface ConfirmDialogProps {
  title: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
  /** A refusal from the server, shown inside the dialog so the person can read it and choose again. */
  error?: string | null;
  children: ReactNode;
}

/** A small confirmation (`role="alertdialog"`) for a consequential action. Focus starts on Cancel, the safe choice. */
export function ConfirmDialog({ title, confirmLabel, onConfirm, onCancel, busy = false, error, children }: ConfirmDialogProps) {
  return (
    <ModalDialog
      title={title}
      role="alertdialog"
      size="sm"
      busy={busy}
      onClose={onCancel}
      footer={(
        <>
          <button type="button" className="jr-btn jr-btn--secondary" data-autofocus onClick={onCancel} disabled={busy}>Cancel</button>
          <button type="button" className="jr-btn jr-btn--primary" onClick={onConfirm} disabled={busy}>
            {busy ? 'Working…' : confirmLabel}
          </button>
        </>
      )}
    >
      {children}
      {error && <p className="jr-error" role="alert">{error}</p>}
    </ModalDialog>
  );
}
